window.addEventListener('DOMContentLoaded', () => {
  const MARPH_URL = 'https://marph.com';

  /**
   * MarphのサイドバーElementsを取得する
   * @returns {Object|null} marphElements
   */
  const getMarphElements = () => {
    const prefix = '.js-sidebar-marph';
    const elements = {
      main: document.querySelector('.sidebar-banner__marph'),
      title: document.querySelector(`${prefix}__title`),
      publishedAt: document.querySelector(`${prefix}__published-at`),
      image: document.querySelector(`${prefix}__image`),
      link: document.querySelector(`${prefix}__link`),
      prLink: document.querySelector(`${prefix}__pr-link`)
    };
    if (Object.values(elements).some((element) => !element)) {
      return null;
    }
    return elements;
  };

  /**
   * UNIX時間をロケールに合わせた日付に変換する
   * @param {number} unixTime UNIX時間
   * @param {string} locate 時間の地域
   * @returns {Object} ロケールに合わせた日付
   */
  const getLocateDateAt = (unixTime, locate) => {
    const date = new Date(parseInt(unixTime) * 1000);
    switch (locate) {
      case 'ja-JP':
        return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      default:
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }
  };

  /**
   * Marphのサイドバーをレンダリングする
   * @param {Object} marphElements MarphのサイドバーElements
   * @param {Object} Marphのデータ
   */
  const renderMarphSidebar = (marphElements, { id, title, publishedAt, imageLink, imageAlt, locate }) => {
    marphElements.image.setAttribute('src', imageLink);
    marphElements.image.setAttribute('alt', imageAlt);
    marphElements.title.textContent = title;
    marphElements.publishedAt.textContent = getLocateDateAt(publishedAt, locate);
    marphElements.link.setAttribute('href', `${MARPH_URL}`);
    marphElements.prLink.setAttribute('href', `${MARPH_URL}/pr/${id}`);
  };

  const marphElements = getMarphElements();
  if (!marphElements) {
    return;
  }

  fetch(`${MARPH_URL}/api/v1/pressreleases?counts=2`)
    .then((response) => response.json())
    .then((data) => {
      if (data?.items?.length === 0) {
        throw new Error('No item data');
      }

      const randomIndex = Math.floor(Math.random() * data.items.length);
      const item = data.items[randomIndex];
      const notExistKeys = [
        'id', 'title', 'publishedAt', 'images'
      ].filter((key) => !(key in item));
      if (notExistKeys.length > 0) {
        throw new Error(`Required key not exits: ${notExistKeys.join(', ')}`);
      }

      renderMarphSidebar(marphElements, {
        id: item.id,
        title: item.title,
        publishedAt: item.publishedAt,
        imageLink: item.images[0]?.lowResolution,
        imageAlt: item.images[0]?.alt,
        locate: 'ja-JP'
      });
    }).catch(() => {
      marphElements.main.remove();
    });
});
